import { AfterViewInit, ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

import { ICellEditorAngularComp } from 'ag-grid-angular';

import { IBarCheckboxCellEditorParams } from './bar-checkbox-cell-editor-params.contract';

@Component({
    selector: 'bar-checkbox-cell-editor',
    templateUrl: './bar-checkbox-cell-editor.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCheckboxModule, FormsModule, ReactiveFormsModule]
})
/** @deprecated in favour of native agCheckboxCellEditor. Checkbox editor component. */
export class BarCheckboxCellEditor implements ICellEditorAngularComp, AfterViewInit {
    readonly input = viewChild<MatCheckbox>('input');
    protected formControl: FormControl;
    protected params: IBarCheckboxCellEditorParams;

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.input().focus();
        });
    }

    agInit(params: IBarCheckboxCellEditorParams): void {
        this.params = params;
        // here we pass the formControl or create one to make the view work
        this.formControl = params.formControl || new FormControl(params.value);
    }

    getValue(): any {
        return this.formControl.value;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isCancelAfterEnd(): boolean {
        return false;
    }

    protected onChange(params: MatCheckboxChange) {
        this.formControl.setValue(params.checked);
        const columnId = this.params.column?.getColId();
        if (columnId) this.params.node.setDataValue(columnId, params.checked);
        setTimeout(() => {
            this.input().focus();
        });
    }

    focusIn() {
        this.input().focus();
    }
}
